import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {
    CmpsButtonModule,
    CmpsDialogModule,
    CmpsRadioModule,
} from '@cmps/ng-uikit';

import { CommitmentService } from '../../coaching-commitment/services/commitment.service';
import { CmpsCommonModule } from '../../common/common.module';
import { CmpsLazyI18nModule } from '../../i18n/i18n.module';

import { TranscriptImportFocusDialogComponent } from './transcript-import-focus-dialog.component';
import { TranslationIdMap } from './transcript-import-focus-dialog.i18n';

@NgModule({
    declarations: [TranscriptImportFocusDialogComponent],
    imports: [
        CmpsButtonModule,
        CmpsCommonModule,
        CmpsDialogModule,
        CmpsLazyI18nModule.forChild(TranslationIdMap),
        CmpsRadioModule,
        CommonModule,
    ],
    providers: [CommitmentService],
})
export class CmpsCoachingTranscriptImportFocusDialogModule {}
